export default __webpack_public_path__ + "static/medgas_manifold_b.f297c49968fe9de20db032753f198fba.png";